import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import * as api from '@services/api/administrators'
import { AdministratorListItem, Administrator, Role } from 'AppTypes'

const initialState = {
  adminList: [] as AdministratorListItem[],
  selectedAdminId: '',
  selectedAdmin: {} as Administrator,
  roleList: [] as Role[],
  isLoading: false,
  keyword: '',
  pageIndex: 1,
  pageSize: 10,
  totalRecords: 0,
  totalPage: 0
}

export const fetchAdministrators = createAsyncThunk(
  'administrators/fetchAdministrators',
  async (params: any) => {
    const response = await api.fetchAdministrators(params)
    return response
  }
)

export const fetchRoles = createAsyncThunk(
  'administrators/fetchRoles',
  async () => {
    const response = await api.fetchRoles()
    return response
  }
)

export const fetchAdminById = createAsyncThunk(
  'administrators/fetchAdminById',
  async (id: string) => {
    const response = await api.fetchAdminById(id)
    return response
  }
)

export const updateAdmin = createAsyncThunk(
  'administrators/updateAdmin',
  async (data: any, { rejectWithValue }) => {
    const response = await api.updateAdmin(data)
    if (!response.success) return rejectWithValue(response.errors)
    return response
  }
)

const administratorsSlice = createSlice({
  name: 'administrator',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setKeyword: (state, action) => {
      state.keyword = action.payload
    },
    selectAdmin: (state, action) => {
      state.selectedAdminId = action.payload
    }
  },
  extraReducers: builders => {
    builders.addCase(fetchAdministrators.fulfilled, (state, action) => {
      state.adminList = action.payload.data
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalRecords = action.payload.totalRecords
      state.totalPage = Math.ceil(action.payload.totalRecords / action.payload.pageSize)
    })
    builders.addCase(fetchAdminById.fulfilled, (state, action) => {
      state.selectedAdmin = action.payload.data
    })
    builders.addCase(fetchRoles.fulfilled, (state, action) => {
      state.roleList = action.payload.data
    })
  }
})

export const {
  setLoading,
  setKeyword,
  selectAdmin
} = administratorsSlice.actions

export default administratorsSlice.reducer
